// import React from "react";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./Home.css";
import heroImage from "../Images/hero.png"; // Ensure the path is correct
import About from "../Components/About";
import Testimonials from "../Components/Testimonials";
import Slider from "../Components/Slider";
import Counter from "../Components/Counter";

const Home = () => {
  const scrollingWords = ["Success", "Fans", "Growth", "Engagement"];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % scrollingWords.length);
    }, 2000); // Change text every 2 seconds

    return () => clearInterval(interval);
  }, []);

  

  return (
    <>
    <section className="heroSection">
    <div className="container-xxl hero-header">
      <div className="container px-lg-5">
        <div className="row g-5 align-items-center">
          {/* Left Content */}
          <div className="col-lg-6 text-center text-lg-start" id="heading1">
            <h1 className="text-white mb-4 animated slideInDown" id="homeh1">
            Real, Instagram Followers
            </h1>


            <div className="social-scroll-container">
      {/* Social Media Button */}
      <Link to="/social-media" className="btn social-btn">
        Social Media
      </Link>

      {/* Scrolling Text */}
      <div className="scrolling-text">
        <span key={currentIndex}>{scrollingWords[currentIndex]}</span>
      </div>
    </div>


            <p className="text-white pb-3 animated slideInDown">
            No bots. No fake users. Build your community with AI targeted IG follower growth.
            <br />
            Trusted by 24,000+ Influencers and Brands for Instagram Follower Growth
            </p>
           
            <Link to="/get-started#payment-section" className="btn py-sm-3 px-sm-5 rounded-pill me-3" id="btn2">
              Get Started
            </Link>
          </div>
          


          {/* Right Side: Image & Video */}
          <div className="col-lg-6 text-center text-lg-start position-relative">
            {/* Hero Image */}
            <img className="img-fluid animated zoomIn" src={heroImage} alt="Hero" id="heroImg" />

            {/* Video (Positioned Over the Image) */}
            <video
              className="hero-video"
              width="200"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={`${process.env.PUBLIC_URL}/4a_1.mp4`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
    </section>
    <About />
    <Testimonials />
    <Slider />
    <Counter />
    </>
    
  );
};

export default Home;
